import React from 'react';
function Archive({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9v11H5V9M21 5H3v4h18V5zM10 13h4" />
    </svg>
  );
}

export default Archive;
